const _temp0 = require("url:../../Game/3d-object-files/BeeTown.glb");
const _temp1 = require("url:../../Game/3d-object-files/Forest 1-2.glb");
const _temp2 = require("url:../../Game/3d-object-files/Level1-1WITHPOND.glb");
const _temp3 = require("url:../../Game/3d-object-files/map.glb");
const _temp4 = require("url:../../Game/3d-object-files/map2.glb");
const _temp5 = require("url:../../Game/3d-object-files/map3.glb");
const _temp6 = require("url:../../Game/3d-object-files/world2/map2.glb");

module.exports = {
  "BeeTown": _temp0,
  "Forest 1-2": _temp1,
  "Level1-1WITHPOND": _temp2,
  "map": _temp3,
  "map2": _temp4,
  "map3": _temp5,
  "world2":   {
    "map2": _temp6
  }
}